// ════════════════════════════════════════════════════════════════════
// Glass-i — Delivery Window API client (Stage DISPATCH-WINDOW-1).
// Base: /api/erp/dispatch/delivery-window (read-only).
// ════════════════════════════════════════════════════════════════════

import client from '../../../api/client';

const BASE = '/api/erp/dispatch/delivery-window';
function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}
const enc = encodeURIComponent;

export const deliveryWindowApi = {
  // KPIs + per-day timeline (full window) + paginated detail rows.
  getWindow: (params = {}) => client.get(BASE, { params }).then(unwrap),
  // Per-line readiness for one work order (the Items popup) — lazy, per WO.
  getWorkOrderLines: (workOrderId) =>
    client.get(`${BASE}/work-orders/${enc(workOrderId)}/lines`).then(unwrap)
};

export default deliveryWindowApi;
